module.exports = "pegasus/assets/follow-us.png";